import { render, staticRenderFns } from "./BirthdayInfinite.vue?vue&type=template&id=74e72403"
import script from "./BirthdayInfinite.vue?vue&type=script&lang=js"
export * from "./BirthdayInfinite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports